"use client";
import { jsx } from "react/jsx-runtime";
import DOMPurify from "isomorphic-dompurify";
import { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { updateSvgContent, getImageMaxDimensions } from "../../../../shared/index.js";
import { ACCORDION_ITEM_ICON_TEST_ID, ACCORDION_ITEM_ICON_MAX_WIDTH, ACCORDION_ITEM_ICON_MAX_HEIGHT } from "./constants.js";
const AccordionItemIcon = ({
  color,
  icon,
  originalSvg
}) => {
  const [sanitizedSvgContent, setSanitizedSvgContent] = useState();
  useEffect(() => {
    const updatedSvg = updateSvgContent(originalSvg, color);
    const sanitizedSvgContent2 = DOMPurify.sanitize(updatedSvg);
    setSanitizedSvgContent(sanitizedSvgContent2);
  }, [color, originalSvg]);
  if (!icon || !originalSvg) {
    return null;
  }
  const iconMaxDimensions = getImageMaxDimensions(
    icon,
    ACCORDION_ITEM_ICON_MAX_HEIGHT,
    ACCORDION_ITEM_ICON_MAX_WIDTH
  );
  return /* @__PURE__ */ jsx(
    Box,
    {
      sx: {
        background: color,
        alignItems: "center",
        display: "flex",
        height: iconMaxDimensions.height,
        justifyContent: "center",
        width: iconMaxDimensions.width
      },
      dangerouslySetInnerHTML: { __html: sanitizedSvgContent ?? "" },
      "data-testid": ACCORDION_ITEM_ICON_TEST_ID
    }
  );
};
export {
  AccordionItemIcon
};
